import ApiService from './ApiService'

export const apiLogIn = data => ApiService.post('/userauth/login/admin/', data)
export const apiLogOut = data => ApiService.post('/userauth/logout/', data)
export const apiChangePassword = data => ApiService.put('/userauth/change-password/', data)
export const apiForgotPassword = data => ApiService.post('userauth/send-reset-password-email/', data)
export const apiResetPassword = (uid, token, data) => ApiService.post(`/userauth/reset-password/${uid}/${token}/`, data)
export const getApiProfile = () => ApiService.get(`/user/profile/`)
export const updateApiProfile = data => ApiService.put(`/user/profile/`, data)
